import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { ListButton } from 'approot/shared/styles/buttons/list-button';
import { spacing24 } from 'approot/shared/styles/spacing.style';

export const VocabularyListItem = styled.li`
  margin-bottom: ${rem(spacing24)};
  position: relative;
`;

export const VocabularyListButton = styled(ListButton)`
  margin-bottom: 0;
  position: relative;
  z-index: 1;
`;

export const VocabularyListButtonContent = styled.div`
  white-space: normal;
`;
